import { createContext, type ReactNode, useContext } from 'react'
import type { FormVariant } from './config'
import { defaultVariant } from './defaultVariant'

type FormContextProps = {
  variant: FormVariant
}

type FormProviderProps = {
  children: ReactNode
} & Partial<FormContextProps>

const FormContext = createContext<FormContextProps>({
  variant: defaultVariant,
})

export const FormProvider = ({ children, variant = defaultVariant }: FormProviderProps) => {
  return <FormContext.Provider value={{ variant }}>{children}</FormContext.Provider>
}

export const useForm = () => useContext(FormContext)
